// extracted by mini-css-extract-plugin
export default {"menuContainer":"dDUDZr3EeyGdcgqQpk28"};